/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 16:22:07
 * @LastEditors: liuziwei
 * @Description: 首页领券 banner
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{isShowCoupon}}" class="coupon-banner-container">
    <!-- 卡片 & 标题部分 -->
    <card-frame class="card-frame" cardConf="{{cardConf}}" bind:clickExtra="clickExtra('receive')">
      <!-- 券组件部分 -->
      <!-- <banner activityId="{{activityId}}" couponList="{{allCoupons}}" /> -->
      <banner  couponList="{{allCoupons}}" bind:clickExtra="clickExtra('coupon')" />
    </card-frame>
    <!-- 浮层部分 -->
    <drawer-frame
      title="我的福利"
      leftTitle="{{true}}"
      open="{{openDrawer}}"
      customStyle="{{drawerCusStyle}}"
      bind:closeDrawer="closeDrawer"
    >
      <!-- <view slot="titleSlot" class="explain" bindtap="clickCouponRules">规则说明</view> -->
      <!-- 券列表部分 -->
      <coupon-list
        received="{{received}}"
        unclaimed="{{unclaimed}}"
        unlock="{{unlock}}"
        bannerFrom="{{bannerFromConf.home}}"
        cityId="{{cityId}}"
      />
    </drawer-frame>
  </view>
</template>

<script>
  import store from '@/store'
  import { createComponent } from '@didi/es-mpx-creator'
  import { bannerFromConf } from '@/config/coupon'
  import { watchEvent } from '@/utils'
  import { goTo } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import { debounce } from '@/utils'
  import { locate } from '@didi/spring-base'

  createComponent({
    data: {
      // drawer 展开状态
      openDrawer: false,
      //卷来源  home  车次列表
      bannerFromConf,
      cityId: 0,
    },
    async attached() {
      const { tripCityId } = await locate()
      // 获取券列表数据
      this.getFlightsCouponData({ cityId: tripCityId }).finally(() => {
        this.isShowCoupon && trackEvent('yks_plane_home_coupon_sw', '迎客松-机票-首页-领券banner-曝光')
      })
      // 监听优惠券更新事件
      watchEvent('updateFlightsCoupon', () => {
        this.getFlightsCouponData({ cityId: tripCityId })
      })
    },
    computed: {
      ...store.mapState({
        flightsCouponData: 'flights.flightsCouponData'
      }),
      // 卡片配置
      cardConf() {
        return {
          title: {
            text: '我的福利',
            color: '#000'
          },
          extra: {
            text:  this.unclaimed?.length>0?'立即领取':'查看',
            color: this.unclaimed?.length>0?'#FF5900':'#999999'
          }
        }
      },
      // pope 活动 id
      // activityId() {
      //   return this.couponData?.activity_id ?? ''
      // },
      // 已领取的券
      received() {
        return this.flightsCouponData?.hasReceiveCoupons ?? []
      },
      // 未领取的券
      unclaimed() {
        return this.flightsCouponData?.toReceiveCouponInfo ?? []
      },
      // 未解锁的券
      unlock() {
        return this.flightsCouponData?.unlockCouponInfo ?? []
      },
      // 服务端去重排好序的全部券数组
      allCoupons() {
        // 未解锁 + 未领取 + 待领取
        const coupon = this.flightsCouponData?.unlockCouponInfo?.concat(
          this.flightsCouponData?.toReceiveCouponInfo,
          this.flightsCouponData?.hasReceiveCoupons
        )
        return coupon ?? []
      },
      // 是否展示优惠券
      isShowCoupon() {
        console.log(this.allCoupons);
        return this.allCoupons.length > 0
      },
      // 自定义 drawer 样式
      drawerCusStyle() {
        return { minHeight: '400px' }
      }
    },
    methods: {
      ...store.mapActions({
        getFlightsCouponData: 'flights.getFlightsCouponData'
      }),
      // 关闭 drawer
      closeDrawer({ type }) {
        if (type === 'closeDrawer') this.openDrawer = false
      },
      // 点击 extra 区域的回调
      clickExtra(button) {
        trackEvent('yks_plane_home_coupon_ck', '迎客松-机票-首页-领券banner-点击', {
          button,
        })
        // 唤起浮层
        this.openDrawer = true
        this.$nextTick(() => {
          trackEvent('yks_plane_home_couponfloat_sw', '迎客松-机票-首页-领券浮层-曝光', {
            page: 'home',
          })
        })
      },
    }
  })
</script>

<style lang='stylus' scoped>
  .card-frame
    background #fff
    font-weight 600
    border-radius 16px
  .explain
    font-size 14px
    color #F86316
    font-weight 500
    margin-left 6px
    position relative
    &::after
      content ''
      top 9px
      right -8px
      position absolute
      width 4px
      height 4px
      border-top 1.5px solid
      border-right 1.5px solid
      transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      banner: './banner',
      'coupon-list': '../coupon-list',
      'card-frame': '../../card-frame',
      'drawer-frame': '../drawer-frame'
    }
  }
</script>
